import React, { Component } from 'react'
import PropTypes from 'prop-types'
import $ from 'lib/jquery'
import Design from 'frontend/pages/gift-cards/design'
import AmountStep from 'frontend/pages/gift-cards/amount-step'
import ModalAlert from 'frontend/components/modal-alert'
import SelectDesign from 'frontend/pages/gift-cards/select-design'
import SuggestedRoomSelect from 'frontend/pages/gift-cards/suggested-room-select'
import RoomDescription from 'frontend/pages/gift-cards/room-description'
import DropdownCalendar from 'frontend/components/dropdown-calendar'
import Current from 'frontend/lib/current'

export default class Constructor extends Component {
  constructor (props) {
    super(props)
    this.fields = [
      'designId',
      'caption',
      'amount',
      'message',
      'receiverName',
      'receiverEmail',
      'suggestedRoomId',
      'sendReceiverEmailAt'
    ]
    this.wordMaxLength = 10
    this.captionMaxLength = 45
    this.state = { errors: {}, caption: '' }
    this.handleSelectDesign = this.handleSelectDesign.bind(this)
    this.handleCaption = this.handleCaption.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleInputValue = this.handleInputValue.bind(this)
    this.handleSuggestedRoom = this.handleSuggestedRoom.bind(this)
    this.handleSendReceiverEmailAtSelect = this.handleSendReceiverEmailAtSelect.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.errorRefs = []
    this.addErrorRef = this.addErrorRef.bind(this)
  }

  componentDidMount () {
    this.fetchTemplates()
  }

  componentDidUpdate () {
    this.scrollToFirstError()
  }

  fetchTemplates () {
    $.ajax({
      type: 'get',
      url: '/' + Current.cityId + '/gift_card_templates.json',
      headers: { 'Key-Inflection': 'camel' },
      error: (response) => {
        console.debug('Constructor#fetchTemplates() error ', response)

        this.setState({ errorMessage: 'Error fetching gift certificates from the server' })
      },
      success: (response) => {
        this.processTemplates(response)
      }
    })
  }

  processTemplates (templates) {
    this.templates = templates
    const designs = []

    templates.forEach((template) => {
      template.designs.forEach((design) => {
        design.template = template
        designs.push(design)
      })
    })
    this.setState({ designs, design: designs[0] })
  }

  handleSelectDesign (design) {
    delete this.state.errors.designId

    this.setState({
      design,
      designId: design.id,
      errors: this.state.errors
    })
  }

  handleCaption (ev) {
    let caption = ev.target.value
    let captionError
    if (
      caption.split(/[^\w]/).find((word) => {
        return word.length > this.wordMaxLength
      })
    ) { captionError = 'Each word should be less than ' + this.wordMaxLength + ' characters long' }

    if (caption.length > this.captionMaxLength) {
      captionError = 'Caption should be less than ' + this.captionMaxLength + ' characters long'
    }

    if (captionError) caption = this.state.caption

    this.setState({
      caption,
      errors: Object.assign(this.state.errors, { caption: captionError })
    })
  }

  handleInput (ev) {
    this.handleInputValue(ev.target)
  }

  handleInputValue ({ name, value }) {
    delete this.state.errors[name]
    this.setState({ [name]: value, errors: this.state.errors })
  }

  handleSuggestedRoom (option) {
    this.setState({ suggestedRoom: option.value, suggestedRoomId: option.value.id })
  }

  handleSendReceiverEmailAtSelect (date) {
    this.setState({ sendReceiverEmailAt: date.isBefore() ? null : date })
  }

  handleSubmit () {
    const { giverId, giverName, giverEmail, giverPhone } = this.props
    const giftCard = { ...{ giverId, giverName, giverEmail, giverPhone } }
    this.fields.forEach((field) => {
      giftCard[field] = this.state[field]
    })

    $.ajax({
      type: 'post',
      url: this.props.resourceUrl
        ? this.props.resourceUrl + '.json'
        : '/' + Current.cityId + '/gift-cards.json',
      contentType: 'application/json',
      data: JSON.stringify(Object.assign({ giftCard }, this.props.data)),
      error: (response) => {
        console.debug('Constructor#handleSubmit() error ', response)
        const json = response.responseJSON
        const errorsFound = json && !!json.errors

        if (json && json.errors) {
          Object.keys(json.errors).forEach((name) => {
            if (this.fields.indexOf(name) === -1) delete json.errors[name]
          })
        }

        if (json && json.errors) {
          this.setState({ errors: json.errors })
        } else if (!json || !json.errors || errorsFound) {
          this.setState({ errorMessage: 'Something went wrong.' })
        }
      },
      success: (response) => {
        this.props.onComplete(response)
      },
      complete: () => {
        this.errorRefs = []
      }
    })
  }

  anyErrors () {
    return (
      this.state.errors &&
      Object.values(this.state.errors).find((e) => {
        return !!e
      })
    )
  }

  addErrorRef (comp) {
    this.errorRefs.push(comp)
  }

  scrollToFirstError () {
    const el = this.errorRefs.find(el => el)
    el && el.scrollIntoView({ behavior: 'smooth' })
  }

  renderFieldError (name) {
    if (this.state.errors[name]) {
      return (
        <div
          className="error"
          ref={(err) => {
            this.addErrorRef(err)
          }}
        >
          {this.state.errors[name]}
        </div>
      )
    }
    return null
  }

  renderSelectedDesign () {
    if (this.state.design) {
      return (
        <Design
          design={this.state.design}
          caption={this.state.caption}
          amount={this.state.amount}
        />
      )
    }

    return <p>Please select one</p>
  }

  renderError () {
    return (
      <ModalAlert
        isOpen={!!this.state.errorMessage}
        title={this.state.errorMessage}
        // body={null}
        onClose={() => {
          this.setState({ errorMessage: null })
        }}
      />
    )
  }

  renderFormError () {
    if (this.anyErrors()) {
      return <div className="form_error">Please fix errors above</div>
    }

    return null
  }

  render () {
    if (this.state.designs) {
      return (
        <div className="gift_card_creator">
          {this.renderError()}
          <div className="your_design sliding">
            <h5>Your design</h5>
            {this.renderSelectedDesign(this.state.design)}
          </div>

          <div className="gift_card_options">
            <div className="step select_design">
              <h4 className="title">
                <span className="fix_title">1. Select best certificate design</span>
              </h4>

              <SelectDesign
                designs={this.state.designs}
                selected={this.state.design}
                onSelect={this.handleSelectDesign}
                amount={this.state.amount}
              />
              {this.renderFieldError('designId')}
            </div>

            <AmountStep
              options={this.state.design?.template?.priceOptions}
              value={(this.state.amount || '').toString()}
              onChange={this.handleInputValue}
              error={this.state.errors.amount}
              disabled={!this.state.design}
              errorRef={this.addErrorRef}/>

            <div className="step select_caption">
              <h4 className="title">
                <span className="fix_title">2. Choose your caption</span>
              </h4>

              <div className="note">45 symbols max.</div>

              <div className="input_wrap gift">
                <input
                  type="text"
                  name="caption"
                  className="input_field"
                  placeholder="Gift Certificate Title"
                  onChange={this.handleCaption}
                  value={this.state.caption || ''}
                  disabled={!this.state.design}
                />
                <label htmlFor="caption" className="input_label">
                  Gift Certificate title
                </label>
              </div>

              {this.renderFieldError('caption')}
            </div>

            <div className="step add_message">
              <h4 className="title">
                <span className="fix_title">
                  4. Add personalized message <small>Optional</small>
                </span>
              </h4>

              <div className="field">
                <textarea
                  name="message"
                  placeholder="Your Message Here"
                  onInput={this.handleInput}
                  // value={this.state.message || ''}
                  disabled={!this.state.design}
                />
                {this.renderFieldError('message')}
              </div>
            </div>

            <div className="step add_contacts_info">
              <h4 className="title">
                <span className="fix_title">5. Contacts</span>
              </h4>

              <div className="fieldset">
                <div className="input_wrap name">
                  <input
                    type="text"
                    name="receiverName"
                    className="input_field"
                    placeholder="Enter Recipient's Name"
                    onChange={this.handleInput}
                    // value={this.state.receiverName || ''}
                    disabled={!this.state.design}
                    required
                  />
                  <label htmlFor="receiverName" className="input_label">
                    Enter Recipient&apos;s Name
                  </label>
                  {this.renderFieldError('receiverName')}
                </div>

                <div className="input_wrap email">
                  <input
                    type="email"
                    name="receiverEmail"
                    className="input_field"
                    placeholder="Enter E-Gift Certificate Recipient's email"
                    onChange={this.handleInput}
                    // value={this.state.receiverEmail || ''}
                    disabled={!this.state.design}
                  />
                  <label htmlFor="receiverEmail" className="input_label">
                    Enter Recipient&apos;s email
                  </label>
                  {this.renderFieldError('receiverEmail')}
                </div>
              </div>
            </div>

            <div className="step select_game">
              <h4 className="title">
                <span className="fix_title">
                  6. Suggest a game <small>Optional</small>
                </span>
              </h4>

              <div className="note">
                You can suggest a game to play! This is just advice, and the receiver is free to
                choose any game they&apos;d like.
              </div>

              <SuggestedRoomSelect
                template={this.state.design ? this.state.design.template : null}
                disabled={!this.state.design}
                selected={this.state.suggestedRoom}
                onSelect={this.handleSuggestedRoom}
              />
              {this.renderFieldError('suggestedRoomId')}
              <RoomDescription room={this.state.suggestedRoom} />
            </div>

            <div className="step select_send_on">
              <h4 className="title">
                <span className="fix_title">
                  6. Send email on <small>Optional</small>
                </span>
              </h4>

              <div className="note">
                Pick a date when the E-Gift Certificate should be delivered.
              </div>

              <DropdownCalendar
                value={this.state.sendReceiverEmailAt}
                placeholder="Now"
                onChange={this.handleSendReceiverEmailAtSelect}
              />
            </div>

            <div className="your_design mobile">
              <h5>Your design</h5>
              {this.renderSelectedDesign(this.state.design)}
            </div>

            <div className="button_place">
              <button className="button" onClick={this.handleSubmit}>
                Send Gift Certificate
              </button>
            </div>

            {this.renderFormError()}
          </div>
        </div>
      )
    } else {
      return (
        <div className="gift_card_loading">
          {this.renderError()}
          <div className="spinner"></div>
          Loading...
        </div>
      )
    }
  }
}

Constructor.propTypes = {
  onComplete: PropTypes.func.isRequired,
  resourceUrl: PropTypes.string,
  giverId: PropTypes.number,
  giverName: PropTypes.string,
  giverEmail: PropTypes.string,
  giverPhone: PropTypes.string
}
